export const url = {
 apiUrl: "https://api.gamerji.tech/api/",
  imgUrl: "https://storage.googleapis.com/gamerji-uploads",
  LANGUAGE_BASE_URL: "https://storage.googleapis.com/gamerji-uploads/languages/gj-st/"
  // fix localhost:8080
};
